const getValuesFromState = (state) => {
  return Object.entries(state).reduce(
    (result, [fieldName, fieldState]) => Object.assign(result, {
      [fieldName]: fieldState ? fieldState.value : ""
    }),
    {}
  );
};
const getValidityFromState = (state) => {
  for (const field in state) {
    if (state.hasOwnProperty(field)) {
      const fieldState = state[field];
      if (fieldState && !fieldState.readonly && fieldState.isValid === false) {
        return false;
      }
    }
  }
  return true;
};
const getValuesFromComposedState = (composedState) => Object.entries(composedState).reduce(
  (acc, [key, state]) => ({ ...acc, [key]: getValuesFromState(state) }),
  {}
);
const isValidComposedState = (state) => Object.values(state).every(getValidityFromState);
export {
  getValidityFromState,
  getValuesFromComposedState,
  getValuesFromState,
  isValidComposedState
};
//# sourceMappingURL=from-state.js.map
